import React, { Component, Fragment } from "react";
import LayoutOperation from "../../components/layout_operation";
import {
  Input,
  Select,
  Modal,
  Upload,
  Spin,
  message,
  DatePicker,
  Form,
} from "antd";
import axios from "axios";
import { PlusOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import Api from "../../services/ServiceApi";
import { changeLang } from "../../actions/langAction";
import moment from "moment";
import ModalSuccess from "../../components/Modal_Success";
import { Link } from "react-router-dom";
class leave_management_detail extends Component {
  leaveForm = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      title: "Leave Form",
      active: 0,
      options: [
        { value: 1, text: "Job ID" },
        { value: 2, text: "Inform Date" },
      ],
      startDate: new Date(),
      DateTime_Install: new Date(),
      current_option: 1,
      data: [],
      fileList: [],
      inform_detail: "",
      form: {},
      modalstatus: false,
      btnName: "",
      urlpath: "",
      status_cancel: false,
      maseter_reject: [],
      ma_period: "-",
      text_modal: "Submission Successful",

      visible_approve: false,
      loading_approve: false,
      visible_reject_failed: false,
      // factupdate : true
      leave_type_list: [
        {   leave_type_id: 1, leave_type_name: "ลาป่วย" },
        {   leave_type_id: 2, leave_type_name: "ลาพักร้อน" },
        {   leave_type_id: 3, leave_type_name: "ลากิจ" },
      ],
      name_list: [],
      default_name: "",
    };
  }
  async componentDidMount() {
    document.title = this.state.title;
    var informdate = new Date();
    var informdate_formated = moment(informdate);
    console.log(informdate_formated);

    await Api.post("get_leave_emp_name", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id:  Cookies.get("project_id"),
      i_where :null,
      emp_id : null
      })
      .then((val) => {
          // console.log(val.data.data)
        
          if(val.data.result.code.toLowerCase() === "p"){
            // set default emp_name
            var result = "";
            console.log(Cookies.get("userId"));
              result = val.data.data.find((user) => { if(user.emp_id == Cookies.get("userId")){ 
              return user;
            }})
              if(result){
                console.log(result);
                this.leaveForm.current.setFieldsValue({
                  emp_id: (result.emp_name !== undefined || result.emp_name !== null ? result.emp_name: null),
                });          
              } 
              this.setState({
                name_list: val.data.data,
              })  
          }
      });

      this.leaveForm.current.setFieldsValue({
        inform_date: informdate_formated,
      })

  }

  checkAsset = (e) => {
    this.setState({
      ckasset: e.target.checked,
      asset_name: "-",
      group_type: "-",
      asset_type: "-",
      ass_sub_type: "-",
      modal_number: "-",
      serial_number: "-",
      date_install: "-",
      warranty: "-",
      asset_ma: "-",
      ass_lat: "",
      ass_long: "",
      ass_name: "",
      ass_code: "",
      asset_id: "",
      area_id: "",
      sub_area_id: "",
    });
  };
  handleInputChange = (event) => {
    var name = event.target.name;
    var value = event.target.value;
    var form = this.state.form;

    // console.log(name);
    // console.log(value);
    // console.log(form);

    form[name] = value;
  };
  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
  };
  handleChange = ({ fileList }) => this.setState({ fileList });
  handleCancel = () => this.setState({ previewVisible: false });
  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };
  
  async handleSubmit(values) {
    console.log(values);
    var get_emp_id;
    if(!Number.isInteger(parseInt(values.emp_id))){
      get_emp_id = this.state.name_list.find((user) => { if(values.emp_id == user.emp_name ){ 
        return user;
      }})
      values.emp_id = get_emp_id.emp_id;
      console.log(values);
    } else {
      // do nothing
      console.log(values);
    }


  
    // console.log(values.leave_type_id);
    // console.log(moment(values.inform_date).format("YYYY-MM-DD HH:mm"));
    // console.log(moment(values.start_date).format("YYYY-MM-DD HH:mm"));
    // console.log(moment(values.end_date).format("YYYY-MM-DD HH:mm"));
    // console.log(values.remark);
    // console.log(values.total_day);
    
    const { fileList } = this.state;
    const formData = new FormData();
    console.log(fileList);

    fileList.forEach((file) => {
      formData.append("files", file["originFileObj"]);
      formData.append( "company_id",    Cookies.get('companyid'));
      formData.append("operator_id",    Cookies.get('operator_id'));
      formData.append("project_id",     Cookies.get('project_id'));
      formData.append("emp_id",         values.emp_id);
      formData.append("leave_type_id",  values.leave_type_id);
      formData.append("inform_date",    moment(values.inform_date).format("YYYY-MM-DD HH:mm"));
      formData.append("start_date",     moment(values.start_date).format("YYYY-MM-DD HH:mm"));
      formData.append("end_date",       moment(values.end_date).format("YYYY-MM-DD HH:mm"));
      formData.append("remark",         values.remark);
      formData.append("status",         "wait approve");
      formData.append("i_create_by",    Cookies.get("userId"));
    });

    if (fileList.length > 0) {
      await axios({
        method: "post",
        url: process.env.REACT_APP_URL_API + "v2/save_leave/",
        data: formData,
        headers: {
          TokenUser: Cookies.get(`OperationToken`),
        },
        processData: false,
      })
        .then((response) => {
          for (
            let i = 0;
            i < formData.getAll("files").length;
            i++
          ) {
            formData.delete("files");
            formData.delete("company_id");
            formData.delete("operator_id");
            formData.delete("project_id");
            formData.delete("emp_id");
            formData.delete("leave_type_id");
            formData.delete("inform_date");
            formData.delete("start_date");
            formData.delete("end_date");
            formData.delete("remark");
            formData.delete("status");
            formData.delete("i_create_by");
            message.success("upload successfully.");
          }
          console.log(response);
          if(response.data.result.code == "P"){
            this.OnViewApprove(this.renderApproveButtonModal())
            this.leaveForm.current.resetFields();
          }else {
              this.OnViewRejectFailed(this.renderRejectButtonModal())
          }
        })
        .catch((response) => {
          //handle error
          console.log(response);
        });
    } else {
      formData.append("files", []);
      formData.append("company_id",    Cookies.get('companyid'));
      formData.append("operator_id",    Cookies.get('operator_id'));
      formData.append("project_id",     Cookies.get('project_id'));
      formData.append("emp_id",         values.emp_id);
      formData.append("leave_type_id",  values.leave_type_id);
      formData.append("inform_date",    moment(values.inform_date).format("YYYY-MM-DD HH:mm"));
      formData.append("start_date",     moment(values.start_date).format("YYYY-MM-DD HH:mm"));
      formData.append("end_date",       moment(values.end_date).format("YYYY-MM-DD HH:mm"));
      formData.append("remark",         values.remark);
      formData.append("status",         "wait approve");
      formData.append("i_create_by",    Cookies.get("userId"));
      
        await axios({
          method: "post",
          url: process.env.REACT_APP_URL_API + "v2/save_leave/",
          data: formData,
          headers: {
            TokenUser: Cookies.get(`OperationToken`),
          },
          processData: false,
        })
          .then( (response) => {
            for (
              let i = 0;
              i < formData.getAll("files").length;
              i++
            ) {
                formData.delete("files");
                formData.delete( "company_id");
                formData.delete("operator_id");
                formData.delete("project_id");
                formData.delete("emp_id");
                formData.delete("leave_type_id");
                formData.delete("inform_date");
                formData.delete("start_date");
                formData.delete("end_date");
                formData.delete("remark");
                formData.delete("status");
                formData.delete("i_create_by");
                message.success("upload successfully.");
              this.setState({
                checkbtn: true,
                // modalstatus: true,
              });
            }
            console.log(response.data.result.code);
            if(response.data.result.code == "P"){
              this.OnViewApprove(this.renderApproveButtonModal())
              this.leaveForm.current.resetFields();
            }else {
              this.OnViewRejectFailed(this.renderRejectButtonModal())
            }
          })
          .catch(function (response) {
            //handle error
            console.log(response);
          });
    }
    
    // await Api.post("save_leave", {
    //   company_id: Cookies.get('companyid'),
    //   operator_id: Cookies.get('operator_id'),
    //   project_id: Cookies.get('project_id'),
    //   emp_id: Cookies.get("userId"),
    //   leave_type_id: values.leave_type_id,
    //   inform_date: moment(values.inform_date).format("YYYY-MM-DD HH:mm"),
    //   start_date: moment(values.start_date).format("YYYY-MM-DD HH:mm"),
    //   end_date: moment(values.end_date).format("YYYY-MM-DD HH:mm"),
    //   remark: values.remark,
    //   status:"wait approve",
    //   total_day: values.total_day,
    //   i_create_by: Cookies.get("userId"),
    //   attach_file:"absent_file.pdf"
    // })
    //   .then((val) => {
    //     console.log(val);
    //     if (val.data.result.code != "F") {
    //         this.OnViewApprove(this.renderApproveButtonModal())
    //         this.leaveForm.current.resetFields();

    //     } else {
    //         this.OnViewRejectFailed(this.renderRejectButtonModal())
    //     }
    // });

  }

  
  renderApproveButtonModal() {
    const { visible_approve, loading_approve } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_approve}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >  
        <Spin spinning={loading_approve}>
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                <img src={Api.absoluteUrl("/icon/approve_check.svg")} alt="approve-ic-check"/>
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                    Submission Successful
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>  window.location.href = "leave_management" }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  calculateStartEndDate(){
      // var result = 
  }

  renderRejectButtonModal() {
    const { visible_reject_failed } = this.state
    return (
        <Fragment>
            <Modal
                centered
                visible={visible_reject_failed}
                footer={null}
                closable={false}
                width={300}
                bodyStyle={{ paddingTop: '0', paddingLeft: '15px', paddingRight: '15px', paddingBottom: '0' }}

            >

                <div className="p-3">
                    <div className="row">
                        <div className="col text-center justify-content-between">
                            <img src={Api.absoluteUrl("/icon/reject.svg")} alt="reject-ic" />
                        </div>
                    </div>

                    <div className="row" style={{ margin: '20px 10px 40px 10px' }}>
                        <div className="col text-center justify-content-between">
                            <span style={{ fontFamily: 'MontserratM', fontWeight: 'bold', color: '#0500A3' }}>
                                <span style={{ color: 'red' }}>Form Rejected, Please Check Your Input</span>
                            </span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col text-center justify-content-between" >
                            <button type="reset" style={{ height: "30px", width: '100px' }} onClick={() => this.setState({ visible_reject_failed: false })} className="btn btn-warning">Ok</button>
                        </div>
                    </div>
                </div>

            </Modal>
        </Fragment>
    );
  }
    // Opening approve
  OnViewApprove(id) {
      this.setState({
          visible_approve: true,
      })
  }

  OnViewRejectFailed(id) {
    this.setState({
        visible_reject_failed: true,
    })
  }

  async filterOnChange(values){
    //  console.log(values)
    if(values[1].value && values[2].value) {

      var startdate = new Date(moment(values[1].value));
      var enddate   = new Date(moment(values[2].value));
      // console.log(startdate);
      // console.log(enddate);

       var total_time =  enddate.getTime()  - startdate.getTime();
      //  console.log(total_time);
       var total_days = parseInt(total_time / (1000 * 3600 * 24) + 1);
      //  console.log(total_days + " Days");

        if(total_days <= 0){
          this.leaveForm.current.setFieldsValue({
            total_day: null
         })
        } else {
          this.leaveForm.current.setFieldsValue({
            total_day: total_days
         })
        }
    } else {
      this.leaveForm.current.setFieldsValue({
        total_day:  null
     })
    }
  }



  render() {
    const {
      title,
      // active,
      // tab,
      // data,
      // current_option,
      // options,
      // columns,
      fileList,
      leave_type_list,
    } = this.state;
    const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    return (
      <LayoutOperation active={5}>
        {/* ====================  Display Modal  ====================*/}
        {this.renderApproveButtonModal()}
        {this.renderRejectButtonModal()}
        {this.state.modalstatus ? (
          <ModalSuccess
            status={this.state.text_modal}
            path_location="/MaxiOperation/leave_management_detail"
          />
        ) : null}

 
        <> 
        <Form  
          onFinish={(values) => this.handleSubmit(values)}  
          onFieldsChange={(_, allFields) => {
            this.filterOnChange(allFields);
           }}      
          ref={this.leaveForm} 
          // initialValues={{
          //   name: this.state.default_name,
          // }}
          >
          <div
            className="d-flex align-items-center"
            style={{
              marginTop: "64px",
              padding: "20px 6px",
              // height: "100px",
              background: "rgb(232, 236, 239)",
            }}
          >
            <div className="container-fluid">
              <div className="d-flex justify-content-between mb-2">
                {/* <Link
                  className="font-thai-r font20 c-white"
                  to="/leave_management"
                >
                  <i
                    className="fas fa-chevron-left"
                    style={{ color: "#2B2D33" }}
                  ></i>
                  <span
                    style={{
                      marginLeft: "5px",
                      marginBottom: "20px",
                      color: "#2B2D33",
                    }}
                  >
                    Back
                  </span>
                </Link> */}
              </div>
              <div className="row m-2">
                     <Link to={{ pathname: '/leave_management' }}>
                            <span style={{ color: '#0500A3', fontSize: '14px' }}> {"<"} </span> 
                            <span style={{ textDecoration: 'underline', color: '#0500A3', fontSize: '14px' }}>Back</span>
                     </Link>
              </div> 
              <div className="row align-items-center">
                <div className="col-3">
                  <img
                    src={Api.absoluteUrl("/icon/plus_blue.svg")}
                    className="mr-3"
                    alt="plus-b-ic"
                  />
                  <h2
                    className="text-uppercase m-0 d-inline-block font-mont-b font20"
                    style={{ color: "#000F9F" }}
                  >
                    {title}
                  </h2>
                </div>
                <div className="col-5">
                  <div className="row justify-content-center">
                    <div className="col-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="font-thai-b c-white font14"></span>
                      </div>
                    </div>
                    <div className="col-3 offset-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="font-thai-b c-white font14"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="wrapper-body" style={{ backgroundColor: "#E8ECEF" }}>
            <div
              className="card"
              style={{ marginRight: "10%", marginLeft: "10%" }}
            > 
              <div className="card-body">
                <div className="row mt-3">
                  <div className="col-2"> </div>

                  <div className="col-10">
                    <img style={{ float: "left", marginTop: "7px", marginRight: "10px",}} src={Api.absoluteUrl("/icon/Asset.svg")} alt="asset-ic"/>
                    <span className="jobdetail">Leave Detail</span>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3"> </div>
                  <div className="col-7">
                    <div className="row">
                      <div className="col-4">
                      
                        <label  className="labeaddjob font-thai-r"  style={{ fontSize: "18px" }} >  Inform date </label>
                        <br />{" "}
                        <Form.Item
                          name="inform_date"
                          // rules={[{ required: true, message: 'Inform date is required' }]}

                        >
                        <DatePicker
                          className="datepicker"
                          // defaultValue={moment(this.state.DateTime_Install,dateFormatList[0])}
                          format={dateFormatList}
                          // onChange={(value) =>
                          // 	this.handleDateChange("date_install", value)
                          // }
                          style={{ width: "90%", color: "yellow", background: "white" }}
                          disabled
                        />
                        </Form.Item>
                      </div>
                      <div className="col-8"></div>

                      <div className="col-4 mt-3">
                      
                        <label
                          className="labeaddjob font-thai-r"
                          style={{ fontSize: "18px" }}
                        >
                          Start date
                        </label>
                        <br />
                        <Form.Item
                          name="start_date"
                          rules={[{ required: true, message: 'Start date is required' }]}
                        >
                        <DatePicker
                          className="datepicker"
                          // defaultValue={moment(
                          //   this.state.DateTime_Install,
                          //   dateFormatList[0]
                          // )}
                          format={dateFormatList}
                          // onChange={(value) =>
                          // 	this.handleDateChange("date_install", value)
                          // }
                          style={{ width: "90%" }}
                        />
                        </Form.Item>
                      </div>
                      <div className="col-4 mt-3">
                     
                        <label className="labeaddjob font-thai-r" style={{ fontSize: "18px" }}> End date </label>
                        <br />
                        <Form.Item
                          name="end_date"
                          rules={[{ required: true, message: 'End date is required' }]}

                        >
                        <DatePicker
                          className="datepicker"
                          // defaultValue={moment(
                          //   this.state.DateTime_Install,
                          //   dateFormatList[0]
                          // )}
                          format={dateFormatList}
                          // onChange={(value) =>
                          // 	this.handleDateChange("date_install", value)
                          // }
                          style={{ width: "90%" }}
                        />
                       </Form.Item>
                      </div>
                      <div className="col-4 mt-3">
                    
                        <label className="font-thai-r" style={{ fontSize: "18px" }}> Total Time (Days).</label>
                        <Form.Item
                          name="total_day"
                          rules={[{ required: true, message: 'Total is required' }]}
                        >
                        <Input
                          style={{ width: "100%", background: "white", color : "#0500A3", cursor: "pointer" }}
                          disabled
                        ></Input>
                        </Form.Item>
                      </div>
                      <div className="col-6 mt-3">
                    
                          <label
                            className="font-thai-r"
                            style={{ fontSize: "18px" }}
                          >
                            Name <b style={{ color: "#DF4547" }}> * </b>
                          </label>
                          <br />
                          <Form.Item
                            name="emp_id"
                            rules={[{ required: true, message: 'Name is required' }]}
                          >
              
                                  <Select
                                            placeholder="Please Select"
                                            style={{color: "#000F9F", cursor: "pointer"}} 
                                            allowClear
                                            showSearch
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                        {( this.state.name_list? this.state.name_list  :  []).map((item, index) => (
                                                <Select.Option            
                                                   key={index}     
                                                   value={item.emp_id} 
                                                          
                                                > 
                                                    {item.emp_name}
                                                </Select.Option>

                                            ))}
                              </Select>
                        </Form.Item>
                      </div>
                      <div className="col-6 mt-3">
                  
                        <label
                          className="labeaddjob font-thai-r"
                          style={{ fontSize: "18px" }}
                        >
                          Leave Type <b style={{ color: "#DF4547" }}> * </b>
                        </label>
                        <br />
                        <Form.Item
                          name="leave_type_id"
                          rules={[{ required: true, message: 'Leave type is required' }]}

                        >
                              <Select
                                placeholder="Leave Type"
                                size="middle"
                              >
                                {(!leave_type_list ? [] : leave_type_list).map((item, index) => (
                                            <Select.Option
                                                value={item.leave_type_id}
                                                key={index}
                                            >
                                                {item.leave_type_name}
                                            </Select.Option>
                                        ))}
                  

                        </Select>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-3"> </div>
                  <div className="col-7">
                    <div className="row">
                      <div className="col-12">
                 
                        <label
                          className="labeaddjob font-thai-r"
                          style={{ fontSize: "18px" }}
                        >
                          Remark
                        </label>
                        <br />
                        <Form.Item
                         name="remark"
                        >
                        <textarea
                          style={{
                            width: "100%",
                            height: "80px",
                            fontSize: "18px",
                          }}
                          // onChange={this.handleInputChange}
                          className="font-thai-r"
                        ></textarea>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="card mt-3"
              style={{ marginRight: "10%", marginLeft: "10%" }}
            >
              <div className="card-body">
                <div className="row mt-3">
                  <div className="col-2"> </div>
                  <div className="col-10">
                    <img
                      style={{
                        float: "left",
                        marginTop: "7px",
                        marginRight: "10px",
                      }}
                      src={Api.absoluteUrl("/icon/Asset.svg")}
                      alt="asset-ic-01"
                    />
                    <span className="jobdetail">Attachment</span>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-12 mt-3" style={{ textAlign: "center" }}>
                    <Upload
                      action={process.env.REACT_APP_URL_API + "mockupupload/"}
                      multiple={true}
                      listType="picture-card"
                      fileList={fileList}
                      onPreview={this.handlePreview}
                      onChange={this.handleChange}
                      height={"20%"}
                    >
                      {this.state.btnName === "Create Job"
                        ? null
                        : fileList.length >= 8
                        ? null
                        : uploadButton}
                    </Upload>
                    <Modal
                      visible={this.state.previewVisible}
                      title={this.state.previewTitle}
                      footer={null}
                      onCancel={this.handleCancel}
                    >
                      <img
                        alt="example"
                        style={{ width: "100%" }}
                        src={this.state.previewImage}
                      />
                    </Modal>
                  </div>
                </div>
              </div>
            </div>{" "}
            <div style={{ textAlign: "center" }} className="mt-3 mb-3">
              <button
                type="submit"
                className="btnbrows"
                // onClick={this.handleSubmit}
              >
                <span style={{ fontSize: "16px" }}>Submit</span>
              </button>
            </div>
          </div>
          </Form>
        </>
      </LayoutOperation>

    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispacthToProps
)(leave_management_detail);
